import { render, staticRenderFns } from "./SidebarInset.vue?vue&type=template&id=a8144d2a"
import script from "./SidebarInset.vue?vue&type=script&lang=ts"
export * from "./SidebarInset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports